import { Inject, Injectable } from '@angular/core';
import {
  HttpClient,
} from '@angular/common/http';
import { AppService } from './app.service';

@Injectable({ providedIn: 'root' })
export class ExternalAuthService extends AppService {
  constructor(
    public http: HttpClient,
    @Inject('environment') environment: any
  ) {
    super(http, environment);
  }

  public getAccessToken = (): Promise<any> => {
    return this.http.post(this.getEndpoint('auth'), {userName: "CGSOSPUBAPI", password: "Bra4+V7wiBi6iw3$tUv5"}).toPromise().then((user: any) => {
      console.log('external auth',user);
      return user;
    });
  }
}
